<template>
  <article class="tr" :id="`tr-${entry.id}`">
    <aside>
      <ul class="tr__iconList">
        <li class="tr__iconItem" v-for="type in entry.t">
          <svg class="tr__icon fa-symbol fa-2x">
            <use :xlink:href="'#' + type.slug"></use>
          </svg>
          <span class="tr__iconItemName">{{ type.title | typeFormat }}</span>
        </li>
      </ul>
    </aside>
    <section class="tr__content">
      <inline-header
        :title="entry.title"
        :url="entry.u"
        :link-text="entry.lt"
      ></inline-header>
      <dl class="detail-list tr__detail-list">
        <dt>Subject(s)</dt>
        <dd>{{ entry.s.length ? entry.s.join(", ") : this.na }}</dd>
        <dt>Grade Level</dt>
        <dd>{{ entry.g.length ? entry.g.join(", ") : this.na }}</dd>
        <dt>Description</dt>
        <dd><curtain-text :maxChars="175" :text="entry.d"></curtain-text></dd>
        <dt v-if="entry.k.length">Keywords</dt>
        <dd v-if="entry.k.length">
          <curtain-tags
            :tags="entry.k"
            v-on:tag-clicked="tagClicked($event)"
          ></curtain-tags>
        </dd>
        <dt>Share</dt>
        <dd>
          <ul class="flex-icon-list">
            <li class="flex-icon-list__item tr__sharingListItem">
              <a
                class="faButton tr__sharingButton"
                :href="fbShareLink"
                target="_blank"
                rel="noreferrer"
              >
                <svg class="fa-symbol fa-3x">
                  <use xlink:href="#facebook"></use>
                </svg>
                <span class="sr-only">Share on facebook</span>
              </a>
            </li>
            <li class="flex-icon-list__item tr__sharingListItem">
              <a
                class="faButton tr__sharingButton"
                :href="pinterestShareLink"
                target="_blank"
                rel="noreferrer"
              >
                <svg class="fa-symbol fa-3x">
                  <use xlink:href="#pinterest"></use>
                </svg>
                <span class="sr-only">Share on Pinterest</span>
              </a>
            </li>
            <li class="flex-icon-list__item tr__sharingListItem">
              <a
                class="faButton tr__sharingButton"
                :href="twitterShareLink"
                target="_blank"
                rel="noreferrer"
              >
                <svg class="fa-symbol fa-3x">
                  <use xlink:href="#twitter"></use>
                </svg>
                <span class="sr-only">Share on Twitter</span>
              </a>
            </li>
            <li class="flex-icon-list__item tr__sharingListItem">
              <a
                class="faButton tr__sharingButton"
                :href="emailShareLink"
                target="_blank"
                rel="noreferrer"
              >
                <svg class="fa-symbol fa-3x">
                  <use xlink:href="#email"></use>
                </svg>
                <span class="sr-only">Share via email</span>
              </a>
            </li>
            <li class="flex-icon-list__item tr__sharingListItem">
              <button
                class="faButton tr__sharingButton"
                title="Copy direct link"
                aria-label="Copy direct link"
                data-balloon="Link copied"
                v-on:click="copyToClipboard($event)"
              >
                <!-- Needs to stay an <i> because SVG symbols doesn't support masks - https://github.com/FortAwesome/Font-Awesome/issues/14231 -->
                <i
                  class="fas fa-link fa-3x"
                  data-fa-transform="shrink-6"
                  data-fa-mask="fas fa-square"
                ></i>
              </button>
            </li>
          </ul>
        </dd>
        <p v-show="copying" class="tr__copyLinkInstructions">
          <span>Copy the following link:</span>
          <span :id="`entry-unique-${entry.id}`">{{ entry.p }}</span>
          <button
            v-on:click="copying = false"
            title="Hide link"
            aria-label="Hide link"
            class="button button--primary"
          >
            <i class="fas fa-check fa-lg"></i> Done
          </button>
        </p>
      </dl>
    </section>
  </article>
</template>

<script>
import curtainText from "./sub-components/curtainText";
import curtainTags from "./sub-components/curtainTags";
import inlineTitleUrl from "./sub-components/inlineTitleUrl";
import "@babel/polyfill";

export default {
  name: "resource",
  props: {
    entry: {
      type: Object,
      required: true,
    },
    na: {
      type: String,
      default: "N/A",
    },
  },
  data() {
    return {
      urlBtnType: "",
      copying: false,
    };
  },
  mounted: function () {
    /*let extension = this.entry.u.substr((this.entry.u.lastIndexOf('.') +1));
            if (!/(pdf|zip|doc)$/ig.test(extension)) {
                alert("Invalid file type: "+extension+".  Please use DOC, PDF or Zip.");
                $("#file").val("");
            }*/
  },
  components: {
    "curtain-text": curtainText,
    "curtain-tags": curtainTags,
    "inline-header": inlineTitleUrl,
  },
  filters: {
    typeFormat: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.replace(/and/g, "&");
    },
  },
  computed: {
    fbShareLink: function () {
      return "https://www.facebook.com/sharer/sharer.php?u=" + this.entry.p;
    },
    pinterestShareLink: function () {
      return (
        "https://pinterest.com/pin/create/button/?media=&url=" +
        this.entry.p +
        "&description=" +
        this.entry.title
      );
    },
    twitterShareLink: function () {
      return (
        "https://twitter.com/intent/tweet?text=%22" +
        this.entry.title +
        "%22%20teaching%20resource%20" +
        this.entry.p
      );
    },
    emailShareLink: function () {
      return (
        "mailto:?subject=Teaching%20Resource%20from%20Bay%20Backpack&body=Check%20out%20the%20%22" +
        this.entry.title +
        "%22%20teaching%20resource%20from%20Bay%20Backpack%3A%20" +
        this.entry.p
      );
    },
  },
  methods: {
    faIcon(type) {
      return faMap[type];
    },
    tagClicked(tag) {
      this.$emit("tag-clicked", tag);
    },
    copyToClipboard(e) {
      this.copying = true;
      const id = this.entry.id;
      this.$nextTick(() => {
        window
          .getSelection()
          .selectAllChildren(document.getElementById("entry-unique-" + id));

        try {
          // copy text
          document.execCommand("copy");

          //immediately hide input
          this.copying = false;
          e.target.focus();

          // copied animation
          e.target.classList.add("confirming");
          setTimeout(function () {
            e.target.classList.remove("confirming");
            e.target.blur();
          }, 3000);
        } catch (err) {
          //Nothing here, if the try fails the user is displayed the link and instructions to copy it
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";
@import "../styles/mixins.scss";

.tr {
  margin: 2rem 0;
  padding-bottom: 2rem;
  border-bottom: 1px solid $gray;
}
.tr__iconList {
  display: flex;
  width: min-content;
  list-style: none;
  padding: 0;
}
.tr__iconItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  min-width: 70px;

  &:not(:last-child) {
    margin-inline-end: 1em;
  }
}
.tr__iconItemName {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: $bold-weight;
  text-align: center;
  line-height: 1.1;
  margin-block-start: 5px;
}
.tr__content {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
.tr__detail-list {
  margin-block-end: 0;
  font-size: 18px;
}
.curtainText a {
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
    color: $link--hover;
  }
}
.tr__copyLinkInstructions {
  font-size: $font-size--small;
  margin-top: 0.5em;

  button {
    font-size: 12px;
    padding: 0.25em 0.5em;
  }
}
.tr__list {
  display: flex;
  flex-wrap: wrap;
}
.tr__sharingListItem:not(:last-child) {
  margin-inline-end: 0.5em;
}
.tr__sharingButton {
  & > * {
    pointer-events: none;
  }

  &[data-balloon] {
    &:before {
      background: no-repeat
        url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E");
      background-size: 100% auto;
      width: 18px;
      height: 6px;
      left: 50%;
      margin-top: 5px;
      top: 100%;
      transform: translate(-50%, -5px);
      opacity: 0;
      pointer-events: none;
      transition: all 0.18s ease-out 0.18s;
      content: "";
      position: absolute;
      z-index: 10;
    }
    &:after {
      opacity: 0;
      pointer-events: none;
      transition: all 0.18s ease-out 0.18s;
      font-size: 0.75rem;
      background: rgba(33, 37, 41, 0.9);
      border-radius: 4px;
      color: #fff;
      content: attr(data-balloon);
      padding: 0.25em 1em;
      position: absolute;
      white-space: nowrap;
      z-index: 10;
      left: 50%;
      margin-top: 11px;
      top: 100%;
      transform: translate(-50%, -5px);
    }
    &.confirming {
      &:before,
      &:after {
        opacity: 1;
      }
    }
  }
}

@media (min-width: 650px) {
  .tr {
    display: flex;
  }
  .tr__iconList {
    flex-direction: column;
    transform: translateY(0);
    margin: 0;
    width: min-content;
  }
  .tr__iconItem {
    margin-inline-end: 1em;
    margin-block-end: 1em;
  }
  .tr__icon {
    width: 75px;
  }
}
</style>
